import { compareValues, type MultiSortOption } from "../../utils/multiColumnSorting";

export type PbjSortColumn<T> = { field: keyof T & string; label: string };

/** One sort axis per column, blanks always last. */
export const pbjSortOptions = <T>(columns: readonly PbjSortColumn<T>[]): MultiSortOption<T>[] =>
	columns.map(({ field, label }) => ({ label, sortColumns: [field], sortNullUndefinedLast: true }));

/** A sort axis matched to `field`'s header click but ordered by what the cell shows. */
export const sortByOtherField = <T>(field: keyof T & string, label: string, orderBy: (row: T) => string | number | null): MultiSortOption<T> => ({
	label,
	sortColumns: [field],
	sortNullUndefinedLast: true,
	// compareValues returns any number; the sort contract wants its sign.
	customSortFunction: (a, b) => Math.sign(compareValues(orderBy(a), orderBy(b))) as 1 | 0 | -1,
});
